import React from "react";
import {SortableHandle } from "react-sortable-hoc";
import Acl from "../../../../hoc/Acl";
import { isSet } from "../../../../utils/commonUtils";
import Icons from "../../Icons";

const NewDragHandler = ({value})=>{
    const {acl,iconType} = value;
   return(
        <td>
            <Acl acl={isSet(acl,'any')}>
                <RowHandler iconType={iconType}/>
            </Acl>
        </td>
    )
}
NewDragHandler.defaultProps ={
    changeHandler:()=>{},
    isSortable:false,
}

export default NewDragHandler;

const RowHandler = ({ iconType="Drag" }) => {
    const SortableIcon = SortableHandle(() => (
        <span className="handle" style={{ cursor: 'grab' }}>
            <Icons type={iconType} />
        </span>
    ));
    return <SortableIcon />;
};